import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, formatErr } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setSession } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sessionId = new URLSearchParams(location.hash.slice(1)).get("session_id");
    const inviteMatch = location.pathname.match(/^\/invite\/([^/]+)/);
    const run = async () => {
      try {
        const { data } = await api.post("/auth/google/session", {
          session_id: sessionId,
          invite_token: inviteMatch ? inviteMatch[1] : null,
        });
        if (!data.user) {
          navigate("/login", { replace: true, state: { pending: data } });
          return;
        }
        setSession(data);
        toast.success(`Signed in as ${data.user.email}`);
        navigate("/", { replace: true });
      } catch (e) {
        toast.error(formatErr(e));
        navigate(inviteMatch ? location.pathname : "/login", { replace: true });
      }
    };
    run();
  }, [location, navigate, setSession]);

  return <div data-testid="auth-callback" className="min-h-screen flex items-center justify-center text-sm text-slate-500">Signing you in…</div>;
}
